/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserProvider = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    user_id: {
      type: 'string',
      isRequired: true,
    },
    provider_id: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
